<div class="slides-container py-4 mb-3 ms-lg-1 me-lg-3 ps-lg-3 pt-lg-5 overflow-x-hidden">
    <div class="container">
        <p class="fs-15 fw-sbold px-3 ps-lg-0">Descubre más<br><span class="span-line"></span></p>
        <div class="cards-container">
            <div class="d-flex cards-wrapper pt-2 pb-3">
                @for(card of showCards; track $index){
                    <div class="card rounded-4 card-width">
                        <img [src]="card.image" class="card-img-top rounded-4 object-fit-cover p-2" alt="...">
                        <div class="card-body ps-4 pe-3">
                          <h5 class="cl-black fw-sbold fs-16">{{ card.title }}</h5>
                          <p class="card-text fw-light fs-13">{{ card.description }}</p>
                          @if(card?.type === 'download-app'){
                            <div class="d-flex justify-content-between">
                                <a class="btn-hover cr-pointer" (click)="openLink('https://play.google.com/store/apps/details?id=com.monific.app')" rel="noopener noreferrer" target="_blank"><img src="https://static.monific.com/assets/assets-app/img/cards/play-store-logo.png" alt=""></a>
                                <a class="btn-hover cr-pointer" (click)="openLink('https://apps.apple.com/mx/app/monific/id1558969085')" rel="noopener noreferrer" target="_blank"><img src="https://static.monific.com/assets/assets-app/img/cards/app-store-logo.png" alt=""></a>
                            </div>
                          }@else{
                              <a 
                              [routerLink]="card?.type === 'link' ? card?.link : '' "
                              (click)="card?.type === 'video' ? openVideo(card?.linkVideo) : '' "
                              (click)="card?.type === 'href' ? openLink(card?.link) : '' "
                              class="btn btn-hover bg-primary cl-white rounded-3"
                              >
                              {{ card?.textButton }}
                            </a>
                          }
                        </div>
                    </div>
                }
            </div>
        </div>
</div>

